import React from "react";
import { styled } from "@lib/components";

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  customStyle?: string;
}

const Content = styled("div")<{ customStyle?: string }>`
  padding: ${({ customStyle }) => (['orders', 'list', 'bump', 'loyalty', 'loyalty-members', 'loyalty-settings'].includes(customStyle || '') ? '19px 0 0 0' : '20px 30px')};
  margin-top: ${({ customStyle, theme }) => (['orders', 'list', 'bump', 'loyalty', 'loyalty-members', 'loyalty-settings'].includes(customStyle || '')
    ? `calc(${theme.top_nav.height - 20}px + var(--cw-safe-top, 0px))`
    : `calc(${theme.top_nav.height + 30}px + var(--cw-safe-top, 0px))`)};
  margin-bottom: ${({ customStyle, theme }) => (['orders', 'list', 'bump', 'loyalty', 'loyalty-members', 'loyalty-settings'].includes(customStyle || '')
    ? `calc(${theme.top_nav.height - 15}px + var(--cw-safe-bottom, 0px))`
    : `calc(${theme.top_nav.height + 5}px + var(--cw-safe-bottom, 0px))`)};
  width: 100%;
  background-color: ${({ customStyle }) => (['orders', 'list', 'bump', 'loyalty'].includes(customStyle || '')? '#fff'  : '')};

 
  ${({ customStyle }) => customStyle && customStyle.includes('loyalty') && `
    background-color: #f0f4f6;
  `}
`;

const RestaurantLayoutContent: React.FC<Props> = (props) => {
  return <Content {...props} />;
};

export default RestaurantLayoutContent;